import * as Sentry from '@sentry/react';
import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import toaster from 'react-hot-toast';
import { purchasePhoneNumber } from 'api/admin/businesses/twilioIntegration';
import { PurchaseTwilioPhoneNumberRequestPayload } from 'types/twilio/twilioAvailablePhoneNumber';

interface usePurchaseTwilioPhoneNumberPayload {
  successCallback?: () => void;
}

export const usePurchaseTwilioPhoneNumber = ({
  successCallback,
}: usePurchaseTwilioPhoneNumberPayload) => {
  return useMutation<
    unknown,
    AxiosError<{ error: string }>,
    PurchaseTwilioPhoneNumberRequestPayload
  >({
    mutationFn: async ({ businessId, data }) => {
      return purchasePhoneNumber({ businessId, data });
    },
    onSuccess: async () => {
      successCallback?.();

      toaster('Phone number has been purchased', {
        icon: '✅',
      });
    },
    onError: (error) => {
      Sentry.captureException(error);
      toaster(error?.response?.data?.error ?? 'An error occurred while purchasing phone number', {
        icon: '❌',
      });
    },
  });
};
